export const mapPurposeConsentCodes = (consentCodes) => {
  return consentCodes.map((code) => {
    switch (code) {
      case 'c51':
        return 'function'
      case 'c52':
        return 'marketing'
      // case 'c53': return 'preferences'
      // case 'c54': return 'measurement'
      // case 'c55': return 'other'
      case 'c56':
        return 'social media'
      default:
        return 'function'
    }
  })
}

export const mapVendorConsentCodes = (consentCodes) => {
  return consentCodes.map((code) => {
    switch (code) {
      case 's40':
        return 'amazon'
      case 's135':
        return 'google-general'
      case 's905':
        return 'google-tag-manager'
      case 's26':
        return 'google-analytics'
      case 's1':
        return 'google-ads'
      case 's1104':
        return 'google-maps'
      case 's30':
        return 'youtube'
      case 's7':
        return 'facebook'
      case 's34':
        return 'twitter'
      case 's14':
        return 'instagram'
      case 'c25490':
        return 'sas360'
      case 'c25492':
        return 'elitechnology'
      // More vendors can be added here...
      default:
        return ''
    }
  })
}

export const parseConsentData = (consentData) => {
  const purposes = mapPurposeConsentCodes(Object.keys(consentData.purposeConsents))
  const vendors = mapVendorConsentCodes(Object.keys(consentData.vendorConsents))
  return purposes.concat(vendors)
}
